import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f46e4e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "personality-button" }
const _hoisted_2 = { class: "p-button-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_loading, {
          key: 0,
          theme: _ctx.loadingTheme
        }, null, 8, ["theme"]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(['personality-button-main', _ctx.type, _ctx.disabled && 'is-disabled', { loading: _ctx.loading }])
        }, [
          _createElementVNode("div", {
            class: "personality-button-container",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickHandler && _ctx.clickHandler(...args)))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ])
          ])
        ], 2))
  ]))
}